module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-1-hover-feb37a86fdf66f0577c2dd62afa1c581.webp";